import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class StoresService {
  create() {
    return securedAxiosInstance.post("/stores");
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/stores", { params: toSnakeCase(params) });
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/stores/${id}`, { params: toSnakeCase(params) });
  }

  updateStatus(storeId, status) {
    return securedAxiosInstance.put(`/stores/${storeId}/update_status`, { status });
  }

  update(storeId, data) {
    return securedAxiosInstance.put(`/stores/${storeId}`, toSnakeCase(data));
  }

  updateGeneralInformations(storeId, data) {
    return securedAxiosInstance.put(`/store/${storeId}/configuration/update_general_informations`, {
      store: toSnakeCase(data),
    });
  }

  getContactInformations(storeId) {
    return securedAxiosInstance.get(`/store/${storeId}/configuration/contact_information`);
  }

  updateContactInformation(storeId, data) {
    return securedAxiosInstance.put(`/store/${storeId}/configuration/update_contact_information`, data);
  }

  getAfterSalesService(storeId) {
    return securedAxiosInstance.get(`/store/${storeId}/configuration/after_sales_service`);
  }

  updateAfterSalesService(storeId, data) {
    return securedAxiosInstance.put(`/store/${storeId}/configuration/update_after_sales_service`, {
      store: toSnakeCase(data),
    });
  }
}

export default new StoresService();
